<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  let mode;

  mode = localStorage.getItem("mode");
  if (!mode) {
    mode = "light";
  }

  function toDark() {
    mode = "dark";
    localStorage.setItem("mode", "dark");
    dispatch("mode", mode);
  }

  function toLight() {
    mode = "light";
    localStorage.setItem("mode", "light");
    dispatch("mode", mode);
  }
</script>

<header class="navbar navbar-expand-md navbar-light d-print-none">
  <div class="container-fluid">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbar-menu"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <h1
      class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3"
    >
      <a href=".">
        <img
          src="./static/logo.svg"
          width="110"
          height="32"
          alt="Tabler"
          class="navbar-brand-image"
        />
      </a>
    </h1>

    <div class="navbar-nav flex-row order-md-last">
      {#if mode == "light"}
        <div class="nav-item  d-md-flex me-1">
          <span class="nav-link px-0" tabindex="-1" on:click={toDark}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-moon"
              width="44"
              height="44"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
              />
            </svg>
          </span>
        </div>
      {/if}
      {#if mode == "dark"}
        <div class="nav-item  d-md-flex me-1">
          <span href="/" class="nav-link px-0" tabindex="-1" on:click={toLight}>
            <!-- Download SVG icon from http://tabler-icons.io/i/bell -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-sun"
              width="44"
              height="44"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <circle cx="12" cy="12" r="4" />
              <path
                d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
              />
            </svg>
          </span>
        </div>
      {/if}

      <div class="nav-item dropdown  d-md-flex me-3">
        <a
          href="/"
          class="nav-link px-0"
          data-bs-toggle="dropdown"
          tabindex="-1"
          aria-label="Show notifications"
        >
          <!-- Download SVG icon from http://tabler-icons.io/i/bell -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path
              d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
            /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /></svg
          >
          <span class="badge bg-red" />
        </a>
        <div class="dropdown-menu dropdown-menu-end dropdown-menu-card">
          <div class="card">
            <div class="card-body">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Accusamus ad amet consectetur exercitationem fugiat in ipsa ipsum,
              natus odio quidem quod repudiandae sapiente. Amet debitis et magni
              maxime necessitatibus ullam.
            </div>
          </div>
        </div>
      </div>
      <div class="nav-item dropdown">
        <a
          href="/"
          class="nav-link d-flex lh-1 text-reset p-0"
          data-bs-toggle="dropdown"
          aria-label="Open user menu"
        >
          <span
            class="avatar avatar-sm"
            style="background-image: url(./static/avatars/000m.jpg)"
          />
          <div class="d-none d-xl-block ps-2">
            <div>Yash Pulse</div>
            <div class="mt-1 small text-muted">Premium</div>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
          <a href="/" class="dropdown-item">Set status</a>
          <a href="/" class="dropdown-item">Profile & account</a>
          <a href="/" class="dropdown-item">Feedback</a>
          <div class="dropdown-divider" />
          <a href="/" class="dropdown-item">Settings</a>
          <a href="/" class="dropdown-item">Logout</a>
        </div>
      </div>
    </div>
  </div>
</header>
